/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Action options
 */
export const actionOptions = {
  default: {},

  scroll_to_section: {
    container: 'all',
    behavior: 'smooth',
    block: 'start',
    inline: 'nearest'
  }
};
